import { OrderState } from '../enums';

export const OrderStateData: { [key: number]: { label: string; class: string; icon?: string; svg?: string } } = {
    [OrderState.Pending]: {
        class: 'item-state-pending',
        label: 'order_state.order_placed',
        icon: '/assets/icons/cart.png'
    },
    [OrderState.Accepted]: {
        class: 'item-state-accepted',
        label: 'order_state.confirmed',
        icon: '/assets/icons/cart-checked.png'
    },
    [OrderState.Rejected]: { class: 'item-state-rejected', label: 'order_state.rejected', svg: 'icon::cancel' },
    [OrderState.InProgress]: { class: 'item-state-in-progress', label: 'order_state.in_progress', svg: 'icon::fried' },
    [OrderState.Available]: { class: 'item-state-available', label: 'order_state.available', svg: 'icon::dish' },
    [OrderState.Canceled]: { class: 'item-state-canceled', label: 'order_state.canceled', svg: 'icon::cancel' },
    [OrderState.Delivering]: {
        class: 'item-state-delivering',
        label: 'order_state.delivering',
        icon: '/assets/icons/in-transit.png'
    },
    [OrderState.Delivered]: { class: 'item-state-delivered', label: 'order_state.delivered', svg: 'icon::delivered' },
    [OrderState.Merged]: { class: 'item-state-merged', label: 'order_state.merged', svg: 'icon::delivered' },
    [OrderState.PendingPayment]: {
        class: 'item-state-pending-payment',
        label: 'order_state.pending_payment',
        svg: 'icon::pending_payment'
    },
    [OrderState.Complete]: { class: 'item-state-complete', label: 'order_state.completed', svg: 'icon::check' },
    [OrderState.DriverAllocated]: {
        class: 'item-state-driver-allocated',
        label: 'order_state.driver_allocated',
        svg: 'icon::delivery-man'
    },
    [OrderState.DriverArrived]: {
        class: 'item-state-driver-arrived',
        label: 'order_state.driver_arrived',
        svg: 'icon::delivery-man'
    },
    [OrderState.PaymentSuccess]: {
        class: 'item-state-payment-success',
        label: 'order_state.payment_success',
        svg: 'icon::payment-success'
    },
    [OrderState.PaymentFailed]: {
        class: 'item-state-payment-failed',
        label: 'order_state.payment_failed',
        svg: 'icon::cancel'
    },

    [OrderState.Custom]: { class: 'item-state-pending', label: '', icon: '/assets/icons/new.png' }
};
